export default __webpack_public_path__ + "static/media/Landing4.c81d4555.png";